import { combineReducers } from '@reduxjs/toolkit';
import { connectRouter } from 'connected-react-router';

import authenticationReducer from '../../features/authenticationSlice';
import rootReducer from '../../features/bootstrapSlice';
import globalMessageReducer from '../../features/globalMessageSlice';

import cityAreaReducer from '../../features/apiFeatures/cityAreaSlice';
import commentDeclineInfoReducer from '../../features/apiFeatures/commentDeclineInfoSlice';
import commentReducer from '../../features/apiFeatures/commentSlice';
import commentStatusReducer from '../../features/apiFeatures/commentStatusSlice';
import commentTypeReducer from '../../features/apiFeatures/commentTypeSlice';
import companyHearingRoleReducer from '../../features/apiFeatures/companyHearingRoleSlice';
import companyReducer from '../../features/apiFeatures/companySlice';
import contentReducer from '../../features/apiFeatures/contentSlice';
import contentTypeReducer from '../../features/apiFeatures/contentTypeSlice';
import fieldReducer from '../../features/apiFeatures/fieldSlice';
import fieldTemplateReducer from '../../features/apiFeatures/fieldTemplateSlice';
import fieldTypeReducer from '../../features/apiFeatures/fieldTypeSlice';
import fieldTypeSpecificationReducer from '../../features/apiFeatures/fieldTypeSpecificationSlice';
import globalContentReducer from '../../features/apiFeatures/globalContentSlice';
import globalContentTypeReducer from '../../features/apiFeatures/globalContentTypeSlice';
import hearingRoleReducer from '../../features/apiFeatures/hearingRoleSlice';
import hearingReducer from '../../features/apiFeatures/hearingSlice';
import hearingStatusReducer from '../../features/apiFeatures/hearingStatusSlice';
import hearingTemplateReducer from '../../features/apiFeatures/hearingTemplateSlice';
import hearingTypeReducer from '../../features/apiFeatures/hearingTypeSlice';
import invitationGroupMappingReducer from '../../features/apiFeatures/invitationGroupMappingSlice';
import invitationGroupReducer from '../../features/apiFeatures/invitationGroupSlice';
import invitationKeyReducer from '../../features/apiFeatures/invitationKeySlice';
import invitationSourceMappingReducer from '../../features/apiFeatures/invitationSourceMappingSlice';
import invitationSourceReducer from '../../features/apiFeatures/invitationSourceSlice';
import kleHierarchyReducer from '../../features/apiFeatures/kleHierarchySlice';
import kleMappingReducer from '../../features/apiFeatures/kleMappingSlice';
import notificationContentReducer from '../../features/apiFeatures/notificationContentSlice';
import notificationContentSpecificationReducer from '../../features/apiFeatures/notificationContentSpecificationSlice';
import notificationContentTypeReducer from '../../features/apiFeatures/notificationContentTypeSlice';
import notificationQueueReducer from '../../features/apiFeatures/notificationQueueSlice';
import notificationReducer from '../../features/apiFeatures/notificationSlice';
import notificationTypeReducer from '../../features/apiFeatures/notificationTypeSlice';
import subjectAreaReducer from '../../features/apiFeatures/subjectAreaSlice';
import userCapacityReducer from '../../features/apiFeatures/userCapacitySlice';
import userHearingRoleReducer from '../../features/apiFeatures/userHearingRoleSlice';
import userReducer from '../../features/apiFeatures/userSlice';
import validationRuleReducer from '../../features/apiFeatures/validationRuleSlice';
import versionReducer from '../../features/apiFeatures/versionSlice';

import administrationPageReducer from '../../features/pageFeatures/administrationPageSlice';
import cityAreaAdministrationPageReducer from '../../features/pageFeatures/cityAreaAdministrationPageSlice';
import createHearingPageReducer from '../../features/pageFeatures/createHearingPageSlice';
import fieldTemplateAdministrationPageReducer from '../../features/pageFeatures/fieldTemplateAdministrationPageSlice';
import GlobalContentAdministrationPageReducer from '../../features/pageFeatures/globalContentAdministrationPageSlice';
import hearingTypeAdministrationPageReducer from '../../features/pageFeatures/hearingTypeAdministrationPageSlice';
import invitationGroupAdministrationPageReducer from '../../features/pageFeatures/invitationGroupAdministrationPageSlice';
import kleMappingAdministrationPageReducer from '../../features/pageFeatures/kleMappingAdministrationPageSlice';
import myHearingsPageReducer from '../../features/pageFeatures/myHearingsPageSlice';
import subjectAreaAdministrationPageReducer from '../../features/pageFeatures/subjectAreaAdministrationPageSlice';

import commentSectionReducer from '../../features/componentFeatures/commentSectionSlice';
import hearingOverviewReducer from '../../features/componentFeatures/hearingOverviewSlice';
import notificationPanelReducer from '../../features/componentFeatures/notificationPanelSlice';
import renderHearingReducer from '../../features/componentFeatures/renderHearingSlice';

import { API_REDUCER, COMPONENT_REDUCER } from '../../constants/store';

const componentReducer = combineReducers({
  [COMPONENT_REDUCER.RENDER_HEARING]: renderHearingReducer,
  [COMPONENT_REDUCER.COMMENT_SECTION]: commentSectionReducer,
  [COMPONENT_REDUCER.HEARING_OVERVIEW]: hearingOverviewReducer,
  [COMPONENT_REDUCER.NOTIFICATION_PANEL]: notificationPanelReducer,
});

const appReducer = combineReducers({
  authentication: authenticationReducer,
  globalMessage: globalMessageReducer,
});

const apiReducer = combineReducers({
  cityArea: cityAreaReducer,
  comment: commentReducer,
  commentDeclineInfo: commentDeclineInfoReducer,
  commentStatus: commentStatusReducer,
  commentType: commentTypeReducer,
  company: companyReducer,
  companyHearingRole: companyHearingRoleReducer,
  content: contentReducer,
  contentType: contentTypeReducer,
  field: fieldReducer,
  fieldTemplate: fieldTemplateReducer,
  fieldType: fieldTypeReducer,
  fieldTypeSpecification: fieldTypeSpecificationReducer,
  globalContentType: globalContentTypeReducer,
  globalContent: globalContentReducer,
  hearingRole: hearingRoleReducer,
  hearing: hearingReducer,
  version: versionReducer,
  hearingStatus: hearingStatusReducer,
  hearingTemplate: hearingTemplateReducer,
  hearingType: hearingTypeReducer,
  [API_REDUCER.INVITATION_GROUP]: invitationGroupReducer,
  [API_REDUCER.INVITATION_GROUP_MAPPING]: invitationGroupMappingReducer,
  [API_REDUCER.INVITATION_KEY]: invitationKeyReducer,
  invitationSource: invitationSourceReducer,
  invitationSourceMapping: invitationSourceMappingReducer,
  kleHierarchy: kleHierarchyReducer,
  kleMapping: kleMappingReducer,
  [API_REDUCER.NOTIFICATION]: notificationReducer,
  [API_REDUCER.NOTIFICATION_CONTENT]: notificationContentReducer,
  [API_REDUCER.NOTIFICATION_CONTENT_SPECIFICATION]: notificationContentSpecificationReducer,
  [API_REDUCER.NOTIFICATION_CONTENT_TYPE]: notificationContentTypeReducer,
  [API_REDUCER.NOTIFICATION_TYPE]: notificationTypeReducer,
  [API_REDUCER.NOTIFICATION_QUEUE]: notificationQueueReducer,
  subjectArea: subjectAreaReducer,
  userCapacity: userCapacityReducer,
  userHearingRole: userHearingRoleReducer,
  user: userReducer,
  validationRule: validationRuleReducer,
});

const pageReducer = combineReducers({
  createHearing: createHearingPageReducer,
  myHearings: myHearingsPageReducer,
  administration: administrationPageReducer,
  cityAreaAdministration: cityAreaAdministrationPageReducer,
  subjectAreaAdministration: subjectAreaAdministrationPageReducer,
  globalContentAdministration: GlobalContentAdministrationPageReducer,
  hearingTypeAdministration: hearingTypeAdministrationPageReducer,
  kleMappingAdministration: kleMappingAdministrationPageReducer,
  fieldTemplateAdministration: fieldTemplateAdministrationPageReducer,
  invitationGroupAdministration: invitationGroupAdministrationPageReducer,
});

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    root: rootReducer,
    app: appReducer,
    api: apiReducer,
    page: pageReducer,
    component: componentReducer,
  });

export default createRootReducer;
